export default __webpack_public_path__ + "static/sdk-stickers-4b5123c1283feff128058cac516984d5.gif";